// Example presets with fashion model images, prompts and extracted clothing results
export interface ExamplePreset {
    id: number;
    name: string;
    preview: string;
    prompt: string;
    results: string[];
}

export const examplePresets: ExamplePreset[] = [
    {
        id: 1,
        name: 'Casual Dress',
        preview: "https://firebasestorage.googleapis.com/v0/b/xdesign-d72cd.appspot.com/o/example_presets%2Ffashion-extractor%2Finput-example-1--compressed.jpg?alt=media&token=e87212c6-09e2-4fcd-a11b-998d6ca14f57",
        prompt: 'Extract dress from image and show dress over white background in product photography style',
        results: [
            "https://firebasestorage.googleapis.com/v0/b/xdesign-d72cd.appspot.com/o/example_presets%2Ffashion-extractor%2Foutput-example-1-compressed.jpg?alt=media&token=53424177-4bcd-403f-8609-82d11c6999ad",
        ]
    },
    {
        id: 2,
        name: 'Casual Dress',
        preview: "https://firebasestorage.googleapis.com/v0/b/xdesign-d72cd.appspot.com/o/example_presets%2Ffashion-extractor%2Finput-example-2-compressed.jpg?alt=media&token=01182ac2-a6d0-4895-84e5-ed0b93422cb8",
        prompt: 'Extract dress from image and show dress over white background in product photography style',
        results: [
            "https://firebasestorage.googleapis.com/v0/b/xdesign-d72cd.appspot.com/o/example_presets%2Ffashion-extractor%2Foutput-example-2-compressed.jpg?alt=media&token=aabf6644-a95b-4e22-b410-466ebec67412",]
    },
    {
        id: 3,
        name: 'Casual Top',
        preview: "https://firebasestorage.googleapis.com/v0/b/xdesign-d72cd.appspot.com/o/example_presets%2Ffashion-extractor%2Finput-example-3-compressed.jpg?alt=media&token=5b664afd-791d-458e-9daa-3ef0fde90609",
        prompt: 'Extract top from image and show top over white background in product photography style',
        results: [
            "https://firebasestorage.googleapis.com/v0/b/xdesign-d72cd.appspot.com/o/example_presets%2Ffashion-extractor%2Foutput-example-3-compressed.jpg?alt=media&token=d5a7c0ae-9e0f-4429-a598-1d23ddfb6f18",]
    }
]; 